const AlreadyVisitedKey = 'gu.alreadyVisited';
export const getAlreadyVisitedCount = () => {
    const alreadyVisited = parseInt(localStorage.getItem(AlreadyVisitedKey) || '', 10);
    return !Number.isNaN(alreadyVisited) ? alreadyVisited : 0;
};
export const setAlreadyVisited = (count) => {
    localStorage.setItem(AlreadyVisitedKey, count.toString());
};
export const incrementAlreadyVisited = () => {
    const alreadyVisited = getAlreadyVisitedCount();
    setAlreadyVisited(alreadyVisited + 1);
};
